import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import cartReducer from "./slices/cartSlice";
import complexOrderCartReducer from "./slices/complexOrderCartSlice";
import complexOrderListReducer from "./slices/complexOrderListSlice";
import categoryListReducer from "./slices/categoryListSlice";
import commonModalReducer from "./slices/commonModalSlice";
import commonStateReducer from "./slices/commonStateSlice";
import currentClusterReducer from "./slices/currentClusterSlice";
import currentUserReducer from "./slices/currentUserSlice";
import orderReducer from "./slices/orderSlice";
import promoReducer from "./slices/promoSlice";
import saleItemListReducer from "./slices/saleItemListSlice";
import storeListReducer from "./slices/storeListSlice";
import syncReducer from "./slices/syncSlice";
import addressReducer from "./slices/addressSlice";
import networkReducer from "./slices/networkSlice";
import paymentMethodsReducer from "./slices/paymentMethodsSlice";
import bonusReducer from "./slices/bonusSlice";
import favoritesReducer from "./slices/favoritesSlice";
import executorReducer from "./slices/executorSlice";
import { cartCacheMiddleware } from "./middleware/cartCacheMiddleware";
import { complexOrderCartCacheMiddleware } from "./middleware/complexOrderCartCacheMiddleware";
import { complexOrdersCacheMiddleware } from "./middleware/complexOrdersCacheMiddleware";
import { ordersCacheMiddleware } from "./middleware/ordersCacheMiddleware";
import { saleItemsCacheMiddleware } from "./middleware/saleItemsCacheMiddleware";
import { syncCacheMiddleware } from "./middleware/syncCacheMiddleware";
import { bonusCacheMiddleware } from "./middleware/bonusCacheMiddleware";
import { addressesCacheMiddleware } from "./middleware/addressesCacheMiddleware";
import { paymentMethodsCacheMiddleware } from "./middleware/paymentMethodsCacheMiddleware";
import { forceStoresCacheMiddleware } from "./middleware/forceStoresCacheMiddleware";
import { favoritesCacheMiddleware } from "./middleware/favoritesCacheMiddleware";

export const store = configureStore({
  reducer: {
    network: networkReducer,
    sync: syncReducer,
    cart: cartReducer,
    complexOrderCart: complexOrderCartReducer,
    complexOrderList: complexOrderListReducer,
    addressList: addressReducer,
    commonModal: commonModalReducer,
    commonState: commonStateReducer,
    currentUser: currentUserReducer,
    currentCluster: currentClusterReducer,
    orderList: orderReducer,
    promoList: promoReducer,
    auth: authReducer,
    saleItemList: saleItemListReducer,
    categoryList: categoryListReducer,
    storeList: storeListReducer,
    bonus: bonusReducer,
    paymentMethods: paymentMethodsReducer,
    favorites: favoritesReducer,
    executor: executorReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      bonusCacheMiddleware,
      cartCacheMiddleware,
      complexOrderCartCacheMiddleware,
      complexOrdersCacheMiddleware,
      ordersCacheMiddleware,
      saleItemsCacheMiddleware,
      syncCacheMiddleware,
      addressesCacheMiddleware,
      paymentMethodsCacheMiddleware,
      forceStoresCacheMiddleware,
      favoritesCacheMiddleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;